import { DateTime } from 'luxon';
import { Id } from '../../shared/id/id';
import { CoreItemType, VertexRelation, VertexRelationAdd, VertexRelationType } from './core-item';

export class SortKeyUtils {
  static parse(sortKey?: string) {
    if (!sortKey) {
      return {};
    }
    const segments = sortKey.split('#');

    if (segments.length === 2) {
      return {
        coreItemType: segments[0] as CoreItemType,
      };
    } else if (segments.length === 4) {
      // relation
      return {
        coreItemType: segments[0] as CoreItemType,
        relation: segments[1] as VertexRelationType,
        toId: segments[2],
      };
    }

    return {};
  }

  static getVertexRelation(
    coreItemBackend: { id: string; sk: string; createdTimeStr?: string },
    config?: { needCreatedTimeStr?: string }
  ): VertexRelation | undefined {
    if (!coreItemBackend.sk) {
      return undefined;
    }
    const segments = coreItemBackend.sk.split('#');
    if (segments.length === 0 || segments[0] !== CoreItemType.relation) {
      return undefined;
    }

    const result: VertexRelation = {
      from: coreItemBackend.id,
      to: segments[2],
      relation: segments[1] as VertexRelationType,
    };

    if (config?.needCreatedTimeStr) {
      result.createdTimeStr = coreItemBackend.createdTimeStr;
    }

    return result;
  }

  static isMetadata(sortKey: string) {
    return this.parse(sortKey)?.coreItemType !== CoreItemType.relation;
  }

  static getRelationCoreItem(relation: VertexRelationAdd, workspaceId: string, createdDate?: DateTime) {
    return {
      id: relation.from,
      sk: SortKeyUtils.getRelationSortKey(relation.relation, {
        toId: relation.to,
        createdDate,
      }),
      ws: workspaceId,
      displayOrderId: relation.displayOrderId,
      version: Id.uuid.generateInBase62(),
    };
  }

  static getRelationSortKey(
    toRelationType?: VertexRelationType,
    config?: { toId?: string; toType?: string; createdDate?: DateTime }
  ) {
    if (!toRelationType) {
      return `${CoreItemType.relation}#`;
    }
    if (config?.toId) {
      if (config?.createdDate) {
        return `${CoreItemType.relation}#${toRelationType}#${config.toId}#${config.createdDate.toFormat('yyyyLLdd')}`;
      }
      return `${CoreItemType.relation}#${toRelationType}#${config.toId}`;
    } else if (config?.toType) {
      return `${CoreItemType.relation}#${toRelationType}#${config.toType}`;
    } else {
      return `${CoreItemType.relation}#${toRelationType}#`;
    }
  }

  /*
  input: userId
  output: 
    1. All Workspace created by user and joined by user

    2. Default Workspace - item
    3. Default Workspace - all certain types items.

    id: workspaceId sk: w
    id: workspaceId sk: userId

    id: CoreItemId sk: <workspaceId>#<core-type>#<ISO-TIME>

    1. sk/id -> All


    SELECT * FROM CoreItem WHERE BEGINS_WITH('sk', 'userId') OR BEGINS_WITH('sk', );

    SELECT * FROM CoreItem WHERE BEGINS_WITH('sk', 'workspaceId#r#20230321')


  */
  static getSortKey(config: { type: CoreItemType; createdDate?: DateTime }) {
    let sortKey = '';
    if (config.type === CoreItemType.workspace) {
      sortKey = `${config.type}`;
    } else if (config.type !== CoreItemType.relation) {
      if (!config.createdDate) {
        return `${config.type}#`;
      }

      sortKey = `${config.type}#${config.createdDate.toFormat('yyyyLLdd')}`;
    }
    return sortKey;
  }
}
